export default "__VITE_ASSET__BFxsMx9X__"